export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const ADMIN_PASSWORD_UPDATE_REQUEST = 'ADMIN_PASSWORD_UPDATE_REQUEST';
export const ADMIN_PASSWORD_UPDATE_SUCCESS = 'ADMIN_PASSWORD_UPDATE_SUCCESS';
export const ADMIN_PASSWORD_UPDATE_FAIL = 'ADMIN_PASSWORD_UPDATE_FAIL';

export const STAFF_LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const STAFF_LOGOUT_FAIL = "LOGOUT_FAIL";

export const HR_LOGOUT_SUCCESS = 'HR_LOGOUT_SUCCESS';
export const HR_LOGOUT_FAIL = 'HR_LOGOUT_FAIL';

export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAIL = 'FETCH_PROFILE_FAIL';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
